import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Index from './pages/Index';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Usuarios from './pages/Usuarios';
import Protocolos from './pages/Protocolos';
import Cidades from './pages/Cidades';
import Secretarias from './pages/Secretarias';
import Subsecretarias from './pages/Subsecretarias';
import TiposDocumentos from './pages/TiposDocumentos';
import CriarDocumento from './pages/CriarDocumento';
import Certificados from './pages/Certificados';
import AdminCertificados from './pages/AdminCertificados';
import ValidarCertificado from './pages/ValidarCertificado';
import Consulta from './pages/Consulta';
import Workflow from './pages/Workflow';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const RootRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Carregando...</div>;
  }

  if (isAuthenticated) {
    return <Layout />;
  }

  // Somente a raiz (/) é pública e mostra o botão "Docline"
  if (location.pathname === '/') {
    return <Index />;
  }

  return <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/validar-certificado/:uuid" element={<ValidarCertificado />} />
      <Route
        path="/"
        element={<RootRoute />}
      >
        <Route index element={<Dashboard />} />
        <Route path="documentos" element={<Protocolos />} />
        <Route path="documentos/enviados" element={<Protocolos />} />
        <Route path="documentos/criar" element={<CriarDocumento />} />
        <Route path="protocolos" element={<Protocolos />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="cidades" element={<Cidades />} />
        <Route path="secretarias" element={<Secretarias />} />
        <Route path="subsecretarias" element={<Subsecretarias />} />
        <Route path="tipos-documentos" element={<TiposDocumentos />} />
        <Route path="certificados" element={<Certificados />} />
        <Route path="admin/certificados" element={<AdminCertificados />} />
                <Route path="consulta" element={<Consulta />} />
                <Route path="workflow" element={<Workflow />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;

